import { render, staticRenderFns } from "./ManageVesselGroups.vue?vue&type=template&id=171efc56&scoped=true&"
import script from "./ManageVesselGroups.vue?vue&type=script&lang=ts&"
export * from "./ManageVesselGroups.vue?vue&type=script&lang=ts&"
import style0 from "./ManageVesselGroups.vue?vue&type=style&index=0&id=171efc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171efc56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSkeletonLoader,VTextField})
